var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("p", { staticClass: "font-bold text-gray-500" }, [
    _vm._v(" " + _vm._s(_vm.tagName) + " "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }